import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../utils/CONSTANTS";
import {View,Text,StyleSheet, PDFViewer, Document, Page} from "@react-pdf/renderer"

const styles = StyleSheet.create({
  columnHeader:{
    fontSize:11,
    fontFamily:"Helvetica-Bold",
    textAlign:"center",
    borderWidth:0.5,
    backgroundColor:"#dedede",
    padding:7,
    height:45

  },
  columnText:{
    fontSize:10,
    textAlign:"center",
    borderWidth:0.5,
    padding:7,
    height:45
  },
  tableheader:{
    fontSize:8,
    textAlign:"center",
    fontFamily:"Helvetica-Bold",
    borderWidth:0.5,
    padding:7,
  }
})

const FdiformPdf = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    consumerName: "",
    compname: "",
    drgno: "",
    partName: "",
    pono: "",
    lotno: "",
    qtyno: "",
    mtcreportno: "",
    batchno: "",
    rework: "",
    date: "",
    table: [
      { id: 1, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 2, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 3, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 4, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 5, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 6, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 7, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
      { id: 8, description: "", specifiedDimensions: "", observedDimensions: ["", "", "", "", ""], measuringInstruments: "", remarks: "" },
    ],
    dimension: "",
    material: "",
    mode: "fdi",
  });
  useEffect(()=>{
    const name = location.state?.name
    if(name){
      fetchData(name)
    }
    else if(searchParams){
      const cardno = searchParams.get("cardno")
      const lotno = searchParams.get("lotno")
      fetchDatabylot_cardno(cardno,lotno);
    }
  },[])

  const fetchData = async (partyName) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product/getByproduct/${partyName}`);
      const result = response.data;
      console.log(result.isparty);
      setFormData(result.isparty);
    } catch (err) {
      console.log(err);

    }
  }
  const fetchDatabylot_cardno = async (cardno,lotno) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/product/getByproduct/${cardno}/${lotno}`);
      const result = response.data;
      console.log(result.isparty);
      setFormData(result.isparty);
    } catch (err) {
      console.log(err);

    }
  }

  return (
    <div className="w-screen h-screen">
    <PDFViewer width="100%" height="100%">
      <Document style={{height:"100%"}}>
        <Page size="A4">
          <View style={{display:"flex",flexDirection:"column",height:"100%",padding:5}}>
            <View style={{display:"flex",flexDirection:"row"}}>
              <View style={{flex:1,borderWidth:0.5}}>
                <View style={{display:"flex",flexDirection:"column",rowGap:15,flex:1,borderWidth:0.5,padding:10}}>
                  <Text style={{fontFamily:"Helvetica-Bold",textAlign:"center",fontSize:15}}>PRECISION PRODUCT</Text>
                  <Text style={{fontFamily:"Helvetica-Bold",textAlign:"center",fontSize:9}}>3/8 Panchwati Compound,Janakpuri,Aligarh-202001</Text>
                </View>
                <View>
                  <View style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>Consumer Name</Text>
                      <Text style={{...styles.columnText}}>{formData.consumerName}</Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>Comp. Name</Text>
                      <Text style={{...styles.columnText}}>{formData.compname}</Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>Drg No</Text>
                      <Text style={{...styles.columnText}}>{formData.drgno}</Text>
                    </View>
                  </View>
                  <View style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>Part Name</Text>
                      <Text style={{...styles.columnText}}>{formData.partName}</Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>P.O. No</Text>
                      <Text style={{...styles.columnText}}>{formData.pono}</Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>Batch No</Text>
                      <Text style={{...styles.columnText,padding:5}}>{formData.cardno}/{formData.lotno}</Text>
                    
                    </View>
                  </View>
                </View>
              </View>
              <View style={{flex:1,borderWidth:0.5}}>
                <View style={{display:"flex",flexDirection:"row",borderWidth:0.5,}}>
                  <View style={{flex:1,height:"100%"}}>
                    <Text style={{...styles.columnHeader,flex:1}}>Consumer's Inspection{"\n"}Report</Text>
                  </View>
                  <View style={{flex:1}}>
                    <Text style={{...styles.columnHeader}}>Report No: {formData.reportno}</Text>
                    <Text style={{...styles.columnHeader}}>Date: {String(new Date().getDate()).padStart(2, '0')}-{String(new Date().getMonth() + 1).padStart(2, '0')}-{new Date().getFullYear()}</Text>
                  </View>
                </View>
                <View>
                  <View style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <View style={{flex:1,flexDirection:"row"}}>
                      <View style={{flex:1}}>
                        <Text style={{...styles.columnHeader}}>Qty No</Text>
                        <Text style={{...styles.columnText}}>{formData.qtyno}</Text>
                      </View>
                      <View style={{flex:1}}>
                        <Text style={{...styles.columnHeader}}>O.K.</Text>
                        <Text style={{...styles.columnText}}>{formData.readonly}</Text>
                      </View>
                    </View>
                    <View style={{flex:1,flexDirection:"row"}}>
                      <View style={{flex:1}}>
                        <Text style={{...styles.columnHeader}}>Rework</Text>
                        <Text style={{...styles.columnText}}>{formData.rework}</Text>
                      </View>
                      <View style={{flex:1}}>
                        <Text style={{...styles.columnHeader}}>Reject</Text>
                        <Text style={{...styles.columnText}}>{formData.reject}</Text>
                      </View>
                    </View>
                  </View>
                  <View style={{display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>MTC Report No</Text>
                      <Text style={{...styles.columnText}}>{formData.mtcreportno}</Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.columnHeader}}>Lot No</Text>
                      <Text style={{...styles.columnText}}>{formData.batchno}</Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
            <View style={{borderWidth:0.5,padding:5}}>
              <View style={{...styles.columnHeader,padding:1,height:25,width:"100%"}}>
                <Text>Observed Dimensions</Text>
              </View>
              <View style={{display:"flex",flexDirection:"row"}}>
                <Text style={{...styles.tableheader,flex:1}}>Sno</Text>
                <Text style={{...styles.tableheader,flex:2}}>Description</Text>
                <Text style={{...styles.tableheader,flex:2}}>Specific{"\n"}Dimensions</Text>
                <Text style={{...styles.tableheader,flex:1}}>Sample 1</Text>
                <Text style={{...styles.tableheader,flex:1}}>Sample 2</Text>
                <Text style={{...styles.tableheader,flex:1}}>Sample 3</Text>
                <Text style={{...styles.tableheader,flex:1}}>Sample 4</Text>
                <Text style={{...styles.tableheader,flex:1}}>Sample 5</Text>
                <Text style={{...styles.tableheader,flex:2}}>Measuring{"\n"}Instruments</Text>
                <Text style={{...styles.tableheader,flex:1}}>Remarks</Text>
              </View>
              {
                formData.table.map((row,idx)=>{
                  return(
                  <View style={{display:"flex",flexDirection:"row"}}>
                    <Text style={{...styles.tableheader,flex:1}}>{idx+1}</Text>
                    <Text style={{...styles.tableheader,flex:2}}>{row.description}</Text>
                    <Text style={{...styles.tableheader,flex:2}}>{row.specifiedDimensions}</Text>
                    <Text style={{...styles.tableheader,flex:1}}>{row.observedDimensions[0]}</Text>
                    <Text style={{...styles.tableheader,flex:1}}>{row.observedDimensions[1]}</Text>
                    <Text style={{...styles.tableheader,flex:1}}>{row.observedDimensions[2]}</Text>
                    <Text style={{...styles.tableheader,flex:1}}>{row.observedDimensions[3]}</Text>
                    <Text style={{...styles.tableheader,flex:1}}>{row.observedDimensions[4]}</Text>
                    <Text style={{...styles.tableheader,flex:2}}>{row.measuringInstruments}</Text>
                    <Text style={{...styles.tableheader,flex:1}}>{row.remarks}</Text>
                  </View>
                  )
                })
              }
            </View>
            <View style={{borderWidth:0.5,padding:5}}>
              <View>
                <Text style={{textAlign:"center",padding:10,fontFamily:"Helvetica-Bold",fontSize:12}}>Rejected Parameters</Text>
              </View>
              <View style={{flexDirection:"column",rowGap:10}}>
                <Text style={{fontSize:10,fontFamily:"Helvetica-Bold"}}>Dimension: {formData.dimension}</Text>
                <Text style={{fontSize:10,fontFamily:"Helvetica-Bold"}}>Material: {formData.material}</Text>
              </View>
              <View style={{flexDirection:"row"}}>
                <View style={{flex:1}}>
                  <Text style={{...styles.tableheader}}>Inspected By</Text>
                  <View style={{flexDirection:"row"}}>
                    <View style={{flex:1}}>
                      <Text style={{...styles.tableheader,backgroundColor:styles.columnHeader.backgroundColor}}>Signature</Text>
                      <Text style={{...styles.tableheader,height:35}}></Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.tableheader,backgroundColor:styles.columnHeader.backgroundColor}}>Date</Text>
                      <Text style={{...styles.tableheader,height:35}}></Text>
                    </View>
                  </View>
                </View>
                <View style={{flex:1}}>
                  <Text style={{...styles.tableheader}}>Verify By</Text>
                  <View style={{flexDirection:"row"}}>
                    <View style={{flex:1}}>
                      <Text style={{...styles.tableheader,backgroundColor:styles.columnHeader.backgroundColor}}>Signature</Text>
                      <Text style={{...styles.tableheader,height:35}}></Text>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{...styles.tableheader,backgroundColor:styles.columnHeader.backgroundColor}}>Date</Text>
                      <Text style={{...styles.tableheader,height:35}}></Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
    </div>
  );
};

export default FdiformPdf;
